import React from "react";

const AddCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_add_circle)">
      <path
        d="M14.6665 14.6667V9.33341H17.3332V14.6667H22.6665V17.3334H17.3332V22.6667H14.6665V17.3334H9.33317V14.6667H14.6665ZM15.9998 29.3334C8.63584 29.3334 2.6665 23.3641 2.6665 16.0001C2.6665 8.63608 8.63584 2.66675 15.9998 2.66675C23.3638 2.66675 29.3332 8.63608 29.3332 16.0001C29.3332 23.3641 23.3638 29.3334 15.9998 29.3334ZM15.9998 26.6667C18.8288 26.6667 21.5419 25.5429 23.5423 23.5426C25.5427 21.5422 26.6665 18.8291 26.6665 16.0001C26.6665 13.1711 25.5427 10.458 23.5423 8.45761C21.5419 6.45722 18.8288 5.33341 15.9998 5.33341C13.1709 5.33341 10.4578 6.45722 8.45736 8.45761C6.45698 10.458 5.33317 13.1711 5.33317 16.0001C5.33317 18.8291 6.45698 21.5422 8.45736 23.5426C10.4578 25.5429 13.1709 26.6667 15.9998 26.6667Z"
        fill="#0033FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_add_circle">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AddCircleIcon;
